import styles from './SearchFilters.module.scss';

interface ISearchFilterStringProps {
  filterName: string;
  filterValue: string;
  removeFilterValue: () => void;
}

export const SearchFilterString = ({ filterName, filterValue, removeFilterValue }: ISearchFilterStringProps) => (
  <div key={filterName} className={styles.FilterWrap}>
    <div className={styles.FilterLabel}>{filterName}</div>
    <div className={styles.FilterWrap}>
      <div className={styles.FilterTextWrap}>
        <div className={styles.FilterText}>{filterValue}</div>
        <div className={styles.FilterRemove} onClick={removeFilterValue} />
      </div>
    </div>
  </div>
);
